import React, { Component } from 'react';
import DataTables from './DataTables';
import Cookie from 'js-cookie';
import { Config } from '../config/config';
import Menu from './Menu';
import Header from './Header';
import { Navigate,Link } from 'react-router-dom';
import Footer from './Footer';
import { ApiGateWay } from '../ApiGateWay/ApiGateWay';
import Spinner from '../UIComponents/Spinner/Spinner';
import MessageBox from '../UIComponents/MessageBox/MessageBox';
import { Helmet } from 'react-helmet';
import * as XLSX from 'xlsx';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import LZString from 'lz-string';
import MessageBoxForInvalidPage from '../UIComponents/MessageBox/MessageBoxForInvalidPage';

class Audits extends Component {
  constructor(props) {
    super(props);
    const config = JSON.parse(Config);
    let stores = JSON.parse(localStorage.getItem('storeData'));
    stores.sort();
    let wareHouses = JSON.parse(localStorage.getItem('warehouseData'));
    // let stores = JSON.parse(Cookie.get('stores'));
    // let wareHouses = JSON.parse(Cookie.get('warehouses'));
    localStorage.removeItem('curStoreID');
    localStorage.removeItem('tabName');
    localStorage.removeItem('store_tabName');
    localStorage.removeItem('warehouse_tabName');

    const jsonData = Cookie.get('currentUser');
    let decompressedData = LZString.decompressFromBase64(jsonData);
    decompressedData = decompressedData =='\x00\x00\x00'?jsonData:decompressedData;
    const user = JSON.parse(decompressedData);
    
    const menu = user['moduleAccess'];
    let date = new Date();
    let month = ('0' + (date.getMonth() + 1)).slice(-2);
    let day = ('0' + date.getDate()).slice(-2);
    let year = date.getFullYear();
    var daynow = new Date();
    daynow.setDate(daynow.getDate());
    var dateStringNow = daynow.toISOString().split('T')[0];

    var dayst = new Date();
    dayst.setDate(dayst.getDate() - 30);
    var dateString = dayst.toISOString().split('T')[0];

    this.state = {
      title: 'Diagnosis',
      data: [],
      alert: '',
      incType: '',
      //storeValue: stores[0].storeId,
      storeValue: '',
      storeSelected: false,
      closure: '',
      stores,
      wareHouses,
      modalOpen: false,
      visible: false,
      tableVisible: false,
      month: month,
      day: day,
      year,
      FromDate: dateString,
      ToDate: dateStringNow,
      codeJson: [],
      submittedByCodeJson: [],
      message: '',
      apiInterface: config['api'],
      proxyjson: [],
      empSubmit: false,
      loading: false,
      submittedBy: '',
      user: menu,
      pageAllowed: false,
    };
    this.handleSelect = this.handleSelect.bind(this);
  }

  handleFromDate = (e) => {
    this.setState(
      {
        FromDate: e.target.value,
      },
      function () {}
    );
  };
  handleToDate = (e) => {
    this.setState(
      {
        ToDate: e.target.value,
      },
      function () {}
    );
  };

  handleClosure = (e) => {
    this.setState(
      {
        closure: e.target.value,
      },
      function () {}
    );
  };

  handleSubmittedBy = (e) => {
    this.setState(
      {
        submittedBy: e.target.value,
      },
      function () {}
    );
  };

  handleStoreValue = (e) => {
    this.setState({
      storeValue: e.target.value,
      loading: true,
      empSubmit: true,
      tableVisible: false,
    });

    ApiGateWay.PostEmp(
      this.state.apiInterface + '/fetchEmpInfo?storeId=' + e.target.value
    )
      .then((response) => response.json())
      .then((response) => {
        if (
          response.errorMessage === 'Token Expired' ||
          response.errorMessage === 'Invalid Token:::JWT expired' ||
          response.errorMessage ===
            'Your session has expired. Please login again.'
        ) {
          Cookie.remove('currentUser');
          Cookie.remove('stores');
          Cookie.remove('storesAll');
          Cookie.remove('warehouses');

          localStorage.clear();
          sessionStorage.clear();
          this.setState({
            loading: false,
            modalOpen: true,
            message:
              'Your session has been expired and you will be redirected to the login page!!',
          });
          setTimeout(() => {
            return (window.location = '/');
          }, 4000);
        }
        this.setState({
          submittedByCodeJson: response,
          visible: true,
        });
      })
      .catch((error) => {
        this.setState({
          loading: false,
          modalOpen: true,
          message: 'Unable to retrieve the data. Please try again later',
        });
      });

    ApiGateWay.paramsPost(
      this.state.apiInterface +
        '/loadHandoverNames?storeId=' +
        e.target.value +
        '&feature=Diagnosis',
      JSON.parse(Cookie.get('token'))
    )
      .then((response) => {
        if (
          response.errorMessage === 'Token Expired' ||
          response.errorMessage === 'Invalid Token:::JWT expired' ||
          response.errorMessage ===
            'Your session has expired. Please login again.'
        ) {
          Cookie.remove('currentUser');
          Cookie.remove('stores');
          Cookie.remove('storesAll');
          Cookie.remove('warehouses');

          localStorage.clear();
          sessionStorage.clear();
          this.setState({
            loading: false,
            modalOpen: true,
            message:
              'Your session has been expired and you will be redirected to the login page!!',
          });
          setTimeout(() => {
            return (window.location = '/');
          }, 4000);
        }
        this.setState({
          codeJson: response,
          loading: false,
          storeSelected: true,
        });
      })
      .catch((error) => {
        this.setState({
          loading: false,
          modalOpen: true,
          message: 'Unable to retrieve the data. Please try again later',
        });
      });
  };
  handleAlert = (e) => {
    this.setState(
      {
        alert: e.target.value,
      },
      function () {}
    );
  };

  handleInctype = (e) => {
    this.setState(
      {
        incType: e.target.value,
      },
      function () {}
    );
  };

  fileDownload(documentPath) {
    this.setState({
      loading: true,
      modalOpen: false,
    });

    let headers = {
      Authorization: 'Bearer ' + JSON.parse(Cookie.get('token')),
      'Access-Control-Allow-Origin': '*',
      'x-api-key': process.env.REACT_APP_X_API_KEY,
    };
    axios
      .get(
        process.env.REACT_APP_UPLOAD_DOWNLOAD +
          this.state.apiInterface +
          '/download?objectId=' +
          documentPath,
        {
          headers: headers,
          responseType: 'blob',
        }
      )
      .then((response) => {
        //Create a Blob from the PDF Stream

        var re = /(?:\.([^.]+))?$/;

        var ext = re.exec(documentPath)[1]; // "txt"
        const MimeTypesMap = {
          png: 'image/png',
          gif: 'image/gif',
          jpg: 'image/jpg',
          jpeg: 'image/jpeg',
          pdf: 'application/pdf',
          mp4: 'video/mp4',
          doc: 'application/msword',
          docx:
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
          ppt: 'application/vnd.ms-powerpoint',
          pptx: 'application/vnd.ms-powerpoint',
          xlsx:
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        };

        const mimeType = MimeTypesMap[ext];

        const file = new Blob([response.data], { type: mimeType });
        //Build a URL from the file
        const fileURL = URL.createObjectURL(file);
        //Open the URL on new Window
        if (mimeType === 'application/pdf') {
          window.open(fileURL, '_blank');
        } else {
          // var filename = fileURL.split('/').pop();
          // var link = document.createElement('a');
          // link.href = fileURL;
          // link.download = filename;
          // document.body.appendChild(link);
          // link.click();
          // document.body.removeChild(link);
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', documentPath); //or any other extension
          document.body.appendChild(link);
          link.click();
        }

        this.setState({
          loading: false,
        });
      })
      .catch((error) => {
        this.setState({
          loading: false,
          modalOpen: true,
          message: 'Unable to retrieve the data. Please try again later',
        });
      });
  }
  handleSelect() {
    let fromDate = this.state.FromDate;
    let toDate = this.state.ToDate;
    if (this.state.storeValue === '') {
      toast.error('Please select the store', {
        position: 'top-right',
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    } else {
      this.setState({
        loading: true,
      });
      let alerts = this.state.alert;
      if (this.state.alert == 'Monthly BSU') {
        alerts = 0;
      }
      ApiGateWay.Post(this.state.apiInterface + '/checklistCategoryDataGrid', {
        fromDate: this.formatDate(fromDate),
        toDate: this.formatDate(toDate),
        storeId: this.state.storeValue,
        submittedBy: this.state.submittedBy,
        name: alerts,
        type: this.state.incType,
        feature: 'Diagnosis',
      })
        .then((response) => response.json())
        .then((response) => {
          this.setState({
            data: response.handoverListCategoryGridModels,
            tableVisible: true,
          });
          let body = [];
          let stores = [];
          let colorCodes = [];
          let storeID = [];

          response.handoverListCategoryGridModels.map((name, val) => {
            if (name.pdfPath == null) {
              body.push([
                name.checklistTime,
                name.checklistName,
                name.checklistType,

                name.userName,
                'No Document Available',
               
                  <Link to="/diagnosis/viewImages" state={{ 
                               title: name,
                               id: 'Diagnosis',
                               fromDate: this.formatDate(this.state.FromDate),
                               toDate: this.formatDate(this.state.ToDate),
                              }} >
                  {'Images'}
                </Link>,  
              ]);
            } else {
              body.push([
                name.checklistTime,
                name.checklistName,
                name.checklistType,

                name.userName,
                <a
                  onClick={() => this.fileDownload(name.pdfPath)}
                  style={{ cursor: 'pointer' }}
                >
                  View Document
                </a>,
              
              <Link to="/diagnosis/viewImages" state={{ 
                    title: name,
                    id: 'Diagnosis',
                    store: this.state.storeValue,
                    fromDate: this.formatDate(this.state.FromDate),
                    toDate: this.formatDate(this.state.ToDate),
                    checklistName: this.state.alert,
                    checklistType: this.state.incType,
                    submittedBy: this.state.submittedBy,
               }} >
                {'Images'}
              </Link>,
              ]);
            }

            stores.push(name.checklistDate);
            storeID.push(name.checklistDate);
            colorCodes.push([0, 0, 0, 0, 0, 0]);
          });
          this.setState({
            proxyjson: {
              type: 'HandoverDateGrid',
              thead: [
                'Date',
                'Time',
                'Checklist Name',
                'Checklist Type',

                'Submitted By',
                'View Document',
                'View Image'
              ],
              storeId: storeID,

              tbody: body,
              columns: [
                'Date',
                'Time',
                'Checklist Name',
                'Checklist Type',

                'Submitted By',
                'View Document',
                'View Image'
              ],
              stores: stores,
              colorCodes: colorCodes,
              popUpDataGrid: body,
            },
            loading: false,
          });
        })
        .catch((error) => {
          this.setState({
            loading: false,
            modalOpen: true,
            message: 'Unable to retrieve the data. Please try again later',
          });
        });
    }
  }

  formatDate = (input) => {
    let input_date = input.toString();
    let datePart = input_date.split('-'),
      year = datePart[0], // get only two digits
      month = datePart[1],
      day = datePart[2];

    return day + '/' + month + '/' + year;
  };
  order = (a, b) => {
    return a < b ? -1 : a > b ? 1 : 0;
  };

  componentDidMount() {
    let future = this.state.user;

    let pageAllow = false;

    future.map((val, index) =>
      val.value == 1
        ? !val.featureAccess
          ? val.featureName == 'Diagnosis'
            ? (pageAllow = true)
            : ''
          : ''
        : ''
    );
    if (pageAllow) {
      this.setState({
        pageAllowed: true,
        loading: true,
        visible: true,
      });

      setTimeout(() => {
        this.setState({
          loading: false,
        });
      }, 1000);
    } else {
      this.setState({
        pageAllowed: false,
        loading: true,
      });
    }
    // ApiGateWay.Get(this.state.apiInterface + '/fetchEmpInfo')
    //   .then((response) => response.json())
    //   .then((response) => {
    //     if (
    //       response.errorMessage === 'Token Expired' ||
    //       response.errorMessage === 'Invalid Token:::JWT expired'
    //     ) {
    //       return (window.location = '/');
    //     }
    //     this.setState({
    //       submittedByCodeJson: response,
    //       visible: true,
    //     });
    //   })
    //   .catch((error) => {
    //     this.setState({
    //       loading: false,
    //       modalOpen: true,
    //       message: 'Unable to retrieve the data. Please try again later',
    //     });
    //   });
    //this.handleSelect('2000-03-12', '2001-03-12');
  }
  render() {
    const { loading, modalOpen, message, pageAllowed } = this.state;

    const exportToExcel = (data, title) => {
      const wb = XLSX.utils.book_new();
      const wsData = [
        ['Checklist Date', 'Time', 'Checklist Name', 'Checklist Type', 'User Name'],
        ...data.map(item => [item.checklistDate, item.checklistTime, item.checklistName, item.checklistType, item.userName])
      ];
      const ws = XLSX.utils.aoa_to_sheet(wsData);
      XLSX.utils.book_append_sheet(wb, ws, title);
      XLSX.writeFile(wb, `${title}.xlsx`);
    };
    let future = this.state.user;

    let pageAllow = false;
    return (
      <>
        {future.map((val, index) =>
          val.value == 1
            ? !val.featureAccess
              ? val.featureName == 'Diagnosis'
                ? (pageAllow = true)
                : ''
              : ''
            : ''
        )}
        {pageAllow === false ? (
       
          <Navigate to="/pageNotAllowed" state={{ id: 'Diagnosis' }} />
        ) : (
          ''
        )}
        <Helmet>
          <title>{this.state.title}</title>
        </Helmet>
        {modalOpen ? (
          <MessageBox
            message={message}
            signout={false}
            onClose={this.handleClose}
          />
        ) : null}

        <div className='wrapper'>
          <Header title={this.state.title} />

          <Menu />
          <div className='content-wrapper'>
            {loading ? (
              <Spinner />
            ) : (
              <section className='content'>
                <div className='row'>
                  <div className='col-md-3 '>
                    <form
                      className='IncidentStoreSelect'
                      style={{ background: 'none', padding: 'none' }}
                    >
                      <div
                        className='form-group'
                        style={{ marginLeft: '-18px' }}
                      >
                        <ToastContainer
                          position='top-right'
                          autoClose={2000}
                          hideProgressBar={false}
                          newestOnTop={false}
                          closeOnClick
                          className=''
                          rtl={false}
                          pauseOnFocusLoss
                          draggable
                          pauseOnHover
                        />
                        <select
                          className='form-control dashInput'
                          value={this.state.storeValue}
                          style={{ width: '390px' }}
                          onChange={this.handleStoreValue}
                        >
                          <option value='' disabled>
                            Select a Store
                          </option>

                          {this.state.stores
                            .sort((a, b) =>
                              a.storeName > b.storeName ? 1 : -1
                            )
                            .map((val, index) => (
                              <option key={val.storeId} value={val.storeId}>
                                {val.storeName}
                              </option>
                            ))}
                          {this.state.wareHouses
                            .sort((a, b) =>
                              a.storeName > b.storeName ? 1 : -1
                            )
                            .map((val, index) => (
                              <option key={val.storeId} value={val.storeId}>
                                {val.storeName}
                              </option>
                            ))}
                        </select>
                      </div>
                    </form>
                  </div>
                  <div className='col-md-3' style={{ marginTop: '13px' }}>
                    <div className='form-group'>
                      <input
                        value={this.state.FromDate}
                        onChange={this.handleFromDate}
                        type='date'
                        style={{ borderRadius: '7px', width: '390px' }}
                        className='form-control dashInput'
                        data-inputmask="'alias': 'dd/mm/yyyy'"
                        data-mask=''
                      />
                    </div>
                  </div>
                  <div className='col-md-3' style={{ marginTop: '13px' }}>
                    <div className='form-group'>
                      <input
                        value={this.state.ToDate}
                        onChange={this.handleToDate}
                        type='date'
                        style={{ borderRadius: '7px', width: '390px' }}
                        className='form-control dashInput'
                        data-inputmask="'alias': 'dd/mm/yyyy'"
                        data-mask=''
                      />
                    </div>
                  </div>
                </div>
                {this.state.visible ? (
                  <div className='row'>
                    <form
                      className='form'
                      style={{ background: 'none', padding: '0% 0%' }}
                    >
                      <div className='col-md-3'></div>
                      <div className='row'></div>
                      <div className='col-md-3'>
                        <div className='form-group'>
                          <select
                            className='form-control dashInput'
                            value={this.state.alert}
                            onChange={this.handleAlert}
                          >
                            <option value=''>Checklist Name</option>
                            {this.state.storeSelected
                              ? this.state.codeJson.checklistInfos.map(
                                  (val, index) => (
                                    <option key={val.value} value={val.value}>
                                      {val.key}
                                    </option>
                                  )
                                )
                              : null}
                          </select>
                        </div>
                      </div>
                      <div className='col-md-3'>
                        <div className='form-group'>
                          <select
                            className='form-control dashInput'
                            value={this.state.incType}
                            onChange={this.handleInctype}
                          >
                            <option value=''>Checklist Type</option>
                            {this.state.alert == 'Monthly BSU'
                              ? this.state.codeJson.checklistInfos.map(
                                  (val, index) => {
                                    return val.key == this.state.alert
                                      ? val.checklistInfos.map((names, ind) => {
                                          return (
                                            <option
                                              key={names.value}
                                              value={names.value}
                                            >
                                              {names.key}
                                            </option>
                                          );
                                        })
                                      : null;
                                  }
                                )
                              : null}
                          </select>
                        </div>
                      </div>
                      <div className='col-md-3'>
                        <div className='form-group'>
                          <select
                            className='form-control dashInput'
                            value={this.state.submittedBy}
                            style={{ width: '390px' }}
                            onChange={this.handleSubmittedBy}
                          >
                            <option value=''>Submitted By</option>
                            {this.state.submittedByCodeJson.empInfos
                              ? this.state.submittedByCodeJson.empInfos.map(
                                  (val, index) => (
                                    <option
                                      key={val.user_id}
                                      value={val.user_id}
                                    >
                                      {val.givenName} {val.surname}
                                    </option>
                                  )
                                )
                              : null}
                          </select>
                        </div>
                      </div>
                      <div className='col-md-2'>
                        <button
                          type='button'
                          onClick={this.handleSelect}
                          className='btn btn-secondary deca-btn-yellow'
                        >
                          SUBMIT
                        </button>
                      </div>
                    </form>
                  </div>
                ) : null}
                <br /> <br />
                {this.state.tableVisible ? (
                  <button
                    className='btn btn-secondary deca-btn-yellow'
                    style={{ marginTop: '-100px', marginBottom: '-50px' }}
                    onClick={() => exportToExcel(this.state.data,this.state.title)}
                  >
                    Export to Excel
                  </button>
                ) : null}
                {this.state.tableVisible ? (
                  <div className='DataGridMain gridbgWhite'>
                    <div style={{ margin: '10px' }}>
                      <DataTables
                        title='DataGrid'
                        count={true}
                        storeDashboard={true}
                        msgVision='vision'
                        data={this.state.proxyjson}
                        name='IncidentsDateGrid'
                      />
                    </div>
                  </div>
                ) : null}
              </section>
            )}
          </div>

          <Footer />
        </div>
      </>
    );
  }
}

export default Audits;
